import { PropsWithChildren } from "react";
import styled from "styled-components";
import { RadioGroup, LinearProgress as LinearProgressUI, RaisedButton } from "@evergis/ui";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LoadingDescription = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin: 1.5rem 0 0.25rem;
`;

export const DownloadButton = styled(RaisedButton)`
  min-width: 7.563rem;
  span[kind]:after {
    margin-right: 0.75rem;
    color: #fff;
  }
  :disabled {
    span[kind]:after {
      color: ${({ theme: { palette } }) => palette.iconDisabled};
    }
  }
`;

export const LinearProgress = styled(LinearProgressUI)`
  margin-top: 0.875rem;
`;

export const Container = styled.div`
  .buttons-group {
    margin-top: -1rem;
    margin-bottom: 0.5rem;
  }
`;

export const ExportRadioGroup = styled(RadioGroup)<PropsWithChildren<unknown>>`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
`;
